import { render, staticRenderFns } from "./MedicationDetailsDialog.vue?vue&type=template&id=38951d73&scoped=true"
import script from "./MedicationDetailsDialog.vue?vue&type=script&lang=js"
export * from "./MedicationDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./MedicationDetailsDialog.vue?vue&type=style&index=0&id=38951d73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38951d73",
  null
  
)

export default component.exports